import { createStyles } from '@material-ui/core';
import { toCssValue, transition } from '@topconagriculture/theme';
export const styles = (theme) => createStyles({
    root: {
        width: '100%',
        height: 'calc(1em + 8px)',
        paddingBottom: 3,
        transition: transition(50),
    },
    label: {
        minWidth: 100,
        fontSize: theme.font.size.mediumSmall,
        color: theme.color.font.dark,
        lineHeight: 1.35,
    },
    field: {
        padding: toCssValue([0, 0]),
        width: '100%',
        fontSize: theme.font.size.medium,
        fontWeight: theme.font.weight.normal,
        lineHeight: theme.font.lineHeight.medium,
        color: `${theme.color.font.dark}!important`,
    },
    checkboxRoot: {
        color: 'inherit',
    },
    optionText: {
        fontWeight: 'inherit',
    },
    disabledInput: {
        cursor: 'default',
        '&:before, &:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error):before': {
            borderBottom: '1px solid rgba(0, 0, 0, 0.38)',
            borderBottomStyle: 'dotted',
        },
    },
});
//# sourceMappingURL=AutocompleteMultiSelectStyles.js.map